import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../css/Nav.css';

const Enlaces = () => {
  const [t] = useTranslation("global");
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para controlar el menú

  // Función para cambiar el estado del menú
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className='nav-div'>
      <nav className='nav-up'>
        <div className='logo-container'>
          {/* Logo */}
          <img src="./EZOSBlanco.png" alt="EZOS Logo" className="logo" />
        </div>

        {/* Icono de hamburguesa */}
        <div className='hamburger-icon' onClick={toggleMenu}>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
        </div>

        {/* Menú desplegable */}
        <ul className={`ul-nav ${isMenuOpen ? 'open' : ''}`}>
          <li className='li-nav'>
            <NavLink to="/home" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('Inicio')}
            </NavLink>
          </li>
          <li className='li-nav'>
            <NavLink to="/llamadas" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('LLamadas')}
            </NavLink>
          </li>
          <li className='li-nav'>
            <NavLink to="/documentacion" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('Documentación necesaria')}
            </NavLink>
          </li>
          <li className='li-nav'>
            <NavLink to="/gestion" className={({ isActive }) => (isActive ? 'active' : '')}>
              {t('Gestión de los CURSOS')}
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Enlaces;
